export var userSelectNoneStyle = "\n  user-select: none;\n";